import React, { useState } from 'react';
import Skid from '../../../assets/icons/new_icon/skid.svg';
import D_Skid from '../../../assets/icons/new_icon/disable_skid.svg';
import DGIcon from '../../../assets/icons/packaging_icons/package.svg';

import Bundle from '../../../assets/icons/new_icon/bundles.svg';
import D_Bundle from '../../../assets/icons/new_icon/disable_bundles.svg';
import Container from '../../../assets/icons/new_icon/container.svg';
import D_Container from '../../../assets/icons/new_icon/disable_container.svg';
import Crate from '../../../assets/icons/new_icon/crate.svg';
import D_Crate from '../../../assets/icons/new_icon/disable_create.svg';
import Package from '../../../assets/icons/new_icon/package.svg';
import D_Package from '../../../assets/icons/new_icon/package-disable.svg';
import Drum from '../../../assets/icons/new_icon/drum.svg';
import D_Drum from '../../../assets/icons/new_icon/disable_drum.svg';
import Envelope from '../../../assets/icons/new_icon/envelop.svg';
import D_Envelope from '../../../assets/icons/new_icon/disable_envelop.svg';
import Pail from '../../../assets/icons/new_icon/pail.svg';
import D_Pail from '../../../assets/icons/new_icon/disable_pail.svg';
import Reel from '../../../assets/icons/new_icon/reel.svg';
import D_Reel from '../../../assets/icons/new_icon/disable_reel.svg';
import Roll from '../../../assets/icons/new_icon/roll.svg';
import D_Roll from '../../../assets/icons/new_icon/disable_roll.svg';
import Totes from '../../../assets/icons/new_icon/totes.svg';
import D_Totes from '../../../assets/icons/new_icon/disable_totes.svg';
import D_Pharma from '../../../assets/icons/new_icon/disable_pharma.svg';
import Pharma from '../../../assets/icons/new_icon/pharma.svg';
import Tube from '../../../assets/icons/new_icon/tube.svg';
import D_Tube from '../../../assets/icons/new_icon/tube_disable.svg';
import Vehicle from '../../../assets/icons/new_icon/vehicle.svg';
import D_Vehicle from '../../../assets/icons/new_icon/disable_vehicle.svg';
import DefaultIcon from '../../../assets/icons/new_icon/package.svg';
import editIcon from '../../../assets/icons/new_icon/edit-2.svg';
import editIconDisable from '../../../assets/icons/new_icon/edit-disable.svg';
import documentIcon from '../../../assets/icons/new_icon/document-2.svg';
import documentIconDisable from '../../../assets/icons/new_icon/document-disable.svg';
import delIcon from '../../../assets/icons/new_icon/delete-2.svg';
import delIconDisable from '../../../assets/icons/new_icon/delete-disable.svg';
import { Tooltip } from 'react-tooltip';
interface Props {
  data: any;
  index: number;
  isSummary?: boolean;
  setPackagesList?: any;
  packagesList?: any;
  setPackagesForm?: any;
  setEditPackageId?: any;
  addPackageValidations?: any;
  setAddPackageValidations?: any;
  setIsEditPackage?: any;
  iseditPackage?: any;
}
function PackageBox({
  data,
  index,
  isSummary,
  setPackagesList,
  packagesList,
  setPackagesForm,
  setEditPackageId,
  addPackageValidations,
  setAddPackageValidations,
  iseditPackage,
  setIsEditPackage,
}: Props) {
  let packageIcon;
  let PackageDisable;

  switch (data?.package_type) {
    case 'BUNDLES':
      packageIcon = Bundle;
      PackageDisable = D_Bundle;
      break;
    case 'DG':
      packageIcon = DGIcon;
      PackageDisable = D_Container;

      break;
    case 'CONTAINER':
      packageIcon = Container;
      PackageDisable = D_Container;

      break;
    case 'CRATE':
      packageIcon = Crate;
      PackageDisable = D_Crate;

      break;
    case 'DRUM':
      packageIcon = Drum;
      PackageDisable = D_Drum;

      break;
    case 'ENVELOPE':
      packageIcon = Envelope;
      PackageDisable = D_Envelope;

      break;
    case 'SKID':
      packageIcon = Skid;
      PackageDisable = D_Skid;

      break;
    case 'PAIL':
      packageIcon = Pail;
      PackageDisable = D_Pail;

      break;
    case 'ROLL':
      packageIcon = Roll;
      PackageDisable = D_Roll;

      break;
    case 'TOTES':
      packageIcon = Totes;
      PackageDisable = D_Totes;

      break;
    case 'REEL':
      packageIcon = Reel;
      PackageDisable = D_Reel;

      break;
    case 'TUBE':
      packageIcon = Tube;
      PackageDisable = D_Tube;

      break;
    case 'VEHICLE':
      packageIcon = Vehicle;
      PackageDisable = D_Vehicle;

      break;
    case 'PHCONR':
      packageIcon = Pharma;
      PackageDisable = D_Pharma;

      break;
    case 'PHREF':
      packageIcon = Pharma;
      PackageDisable = D_Pharma;

      break;
    case 'PHEXR':
      packageIcon = Pharma;
      PackageDisable = D_Pharma;

      break;
    case 'PHFRO':
      packageIcon = Pharma;
      PackageDisable = D_Pharma;

      break;
    default:
      packageIcon = DefaultIcon;
      PackageDisable = D_Package;
  }
  let dim = data?.units === '0' ? 'cm' : 'in';
  let weightUnit = data?.units === '0' ? 'kg' : 'lbs';

  let shipping_name = data?.proper_shipping_name;

  shipping_name += data?.is_nos ? `, ${data?.is_nos}` : '';
  shipping_name += data?.is_neq ? `, ${data?.is_neq}` : '';

  function removePackage() {
    if (setPackagesList) {
      const updatedPackagesList = [...packagesList];
      updatedPackagesList.splice(index, 1);
      setPackagesList(updatedPackagesList);
    }
  }
  function copyPackage() {
    if (setPackagesForm && addPackageValidations && setAddPackageValidations) {
      setPackagesForm(data);
      const updatedValidations = Object.fromEntries(
        Object.keys(addPackageValidations).map((key) => [key, true])
      );
      setAddPackageValidations(updatedValidations);
    }
  }
  function editPackage() {
    setIsEditPackage(data?.id);
    if (setEditPackageId) {
      setEditPackageId(data?.id);
      setPackagesForm(data);
      const updatedValidations = Object.fromEntries(
        Object.keys(addPackageValidations).map((key) => [key, true])
      );
      setAddPackageValidations(updatedValidations);
    }
  }
  return (
    <div id={`p${index}`}>
      {iseditPackage === data?.id ? (
        <div
          className='ubbe-edit-card   mt-4'
          style={{ cursor: 'not-allowed' }}
        >
          <div className='card-body p-3'>
            <div className='package w-100 d-flex justify-content-between '>
              <div className='d-flex gap-2'>
                <div>
                  {' '}
                  <img
                    id='package-image'
                    // src={packageIcon}
                    src={PackageDisable}
                    alt=''
                  />
                </div>

                <div>
                  <h6 className='globalInputLabel disable_globalInputLabel'>
                    <span>{data?.package_description}</span>
                  </h6>
                  <h6 className='globalInputLabel disable_globalInputLabel'>
                    {data?.description}
                  </h6>
                  <h6 className='disable_globalInputLabel'>
                    <span>
                      {data?.quantity} @ {data?.length}
                      <span className='dim-unit'>{dim}</span> x {data?.width}
                      <span className='dim-unit'>{dim}</span> x {data?.height}
                      <span className='dim-unit'>{dim}</span> - {data?.weight}
                      <span className='weight-unit'>{weightUnit}</span>
                    </span>
                  </h6>
                  {data?.package_type === 'SKID' && (
                    <h6 className='disable_globalInputLabel'>
                      Freight Class: {data?.freight_class}
                    </h6>
                  )}
                  {data?.package_type === 'CONTAINER' && (
                    <div className='disable_globalInputLabel'>
                      <h6>Container Number - {data?.container_number}</h6>
                      <h6>Container Status - {data?.status_name}</h6>
                    </div>
                  )}
                  {data?.is_dangerous_good && (
                    <div className='disable_globalInputLabel'>
                      <h6 className='text-danger'>
                        DG QTY: {data?.dg_quantity} - UN/ID: {data?.un_number}
                      </h6>
                      <h6 className='text-danger'>{shipping_name}</h6>
                      <h6 className='text-danger'>
                        Group: {data?.packing_group_name}
                      </h6>
                      <h6 className='text-danger'>
                        Packing Type: {data?.packing_type_name}
                      </h6>
                    </div>
                  )}
                  {data?.is_pharma && (
                    <>
                      <h6 className='text-danger disable_globalInputLabel'>
                        Chain of Signature Required:{' '}
                        {data?.is_cos ? 'Yes' : 'No'}
                      </h6>

                      <h6 className='text-danger disable_globalInputLabel'>
                        Time Sensitive:{' '}
                        {data?.is_time_sensitive
                          ? data?.time_sensitive_hours
                          : ''}{' '}
                        Hours
                      </h6>
                    </>
                  )}
                  {data?.package_type === 'VEHICLE' && (
                    <div className='disable_globalInputLabel'>
                      <h6>
                        {data?.year} - {data?.make} - {data?.model}
                      </h6>
                      <h6>VIN - {data?.vin}</h6>
                      <h6>
                        Running Condition -{' '}
                        {data?.condition
                          ? `${data.condition
                              .charAt(0)
                              .toUpperCase()}${data.condition
                              .slice(1)
                              .toLowerCase()}`
                          : ''}
                      </h6>
                      <h6>
                        Anti-Theft -{' '}
                        {data?.anti_theft
                          ? `${data.anti_theft
                              .charAt(0)
                              .toUpperCase()}${data.anti_theft
                              .slice(1)
                              .toLowerCase()}`
                          : ''}
                      </h6>
                    </div>
                  )}
                </div>
              </div>
              {!isSummary && (
                <div className='d-flex flex-column gap-3'>
                  <button className='btn-ubbe-no-style'>
                    <img
                      src={editIconDisable}
                      className='packageBoxIcon'
                      style={{ backgroundColor: '#6B6B6C1A' }}
                    />
                  </button>
                  <button className='btn-ubbe-no-style'>
                    <img
                      src={delIconDisable}
                      className='packageBoxIcon'
                      style={{ backgroundColor: '#6B6B6C1A' }}
                    />
                  </button>
                  <button className='btn-ubbe-no-style'>
                    <img
                      src={documentIconDisable}
                      className='packageBoxIcon'
                      style={{ backgroundColor: '#6B6B6C1A' }}
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className='ubbe-new-card   mt-4'>
          <div className='card-body p-3'>
            <div className='package w-100 d-flex justify-content-between '>
              <div className='d-flex gap-2'>
                <div>
                  {' '}
                  <img
                    id='package-image'
                    src={packageIcon}
                    // src={Package}
                    alt=''
                  />
                </div>

                <div>
                  <h6 className='globalInputLabel'>
                    <span>{data?.package_description}</span>
                  </h6>
                  <h6 className='globalInputLabel'>{data?.description}</h6>
                  <h6 className=''>
                    <span>
                      {data?.quantity} @ {data?.length}
                      <span className='dim-unit'>{dim}</span> x {data?.width}
                      <span className='dim-unit'>{dim}</span> x {data?.height}
                      <span className='dim-unit'>{dim}</span> - {data?.weight}
                      <span className='weight-unit'>{weightUnit}</span>
                    </span>
                  </h6>
                  {data?.package_type === 'SKID' && (
                    <h6>Freight Class: {data?.freight_class}</h6>
                  )}
                  {data?.package_type === 'CONTAINER' && (
                    <>
                      <h6>Container Number - {data?.container_number}</h6>
                      <h6>Container Status - {data?.status_name}</h6>
                    </>
                  )}
                  {data?.is_dangerous_good && (
                    <>
                      <h6 className='text-danger'>
                        DG QTY: {data?.dg_quantity} - UN/ID: {data?.un_number}
                      </h6>
                      <h6 className='text-danger'>{shipping_name}</h6>
                      <h6 className='text-danger'>
                        Group: {data?.packing_group_name}
                      </h6>
                      <h6 className='text-danger'>
                        Packing Type: {data?.packing_type_name}
                      </h6>
                    </>
                  )}
                  {data?.is_pharma && (
                    <>
                      <h6 className='text-danger'>
                        Chain of Signature Required:{' '}
                        {data?.is_cos ? 'Yes' : 'No'}
                      </h6>

                      <h6 className='text-danger'>
                        Time Sensitive:{' '}
                        {data?.is_time_sensitive
                          ? data?.time_sensitive_hours
                          : ''}{' '}
                        Hours
                      </h6>
                    </>
                  )}
                  {data?.package_type === 'VEHICLE' && (
                    <>
                      <h6>
                        {data?.year} - {data?.make} - {data?.model}
                      </h6>
                      <h6>VIN - {data?.vin}</h6>
                      <h6>
                        Running Condition -{' '}
                        {data?.condition
                          ? `${data.condition
                              .charAt(0)
                              .toUpperCase()}${data.condition
                              .slice(1)
                              .toLowerCase()}`
                          : ''}
                      </h6>
                      <h6>
                        Anti-Theft -{' '}
                        {data?.anti_theft
                          ? `${data.anti_theft
                              .charAt(0)
                              .toUpperCase()}${data.anti_theft
                              .slice(1)
                              .toLowerCase()}`
                          : ''}
                      </h6>
                    </>
                  )}
                </div>
              </div>
              <Tooltip id='my-tooltip' />

              {!isSummary && (
                <div className='d-flex flex-column gap-3'>
                  <button
                    className='btn-ubbe-no-style'
                    data-tooltip-place='left'
                    data-tooltip-id='my-tooltip'
                    data-tooltip-content={'Edit'}
                    onClick={() => {
                      //   "edit_package('${id}')";
                      editPackage();
                    }}
                  >
                    <img
                      src={editIcon}
                      className='packageBoxIcon'
                      style={{ backgroundColor: 'rgba(26, 97, 204, 0.10)' }}
                    />
                  </button>
                  <button
                    className='btn-ubbe-no-style'
                    onClick={() => {
                      // "copy_package('${id}')"
                      copyPackage();
                    }}
                  >
                    <img
                      src={documentIcon}
                      data-tooltip-place='left'
                      data-tooltip-id='my-tooltip'
                      data-tooltip-content={'Copy'}
                      className='packageBoxIcon'
                      style={{ backgroundColor: 'rgba(49, 188, 14, 0.10)' }}
                    />
                  </button>
                  <button
                    className='btn-ubbe-no-style'
                    data-tooltip-place='left'
                    data-tooltip-id='my-tooltip'
                    data-tooltip-content={'Delete'}
                    onClick={() => {
                      // remove_package
                      removePackage();
                    }}
                  >
                    <img
                      src={delIcon}
                      className='packageBoxIcon'
                      style={{ backgroundColor: 'rgba(252, 0, 0, 0.10)' }}
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PackageBox;
